import { useEffect, useState } from "react";
import {
  Button,
  Flex,
  FormLabel,
  Input,
  Text,
  FormControl,
  FormErrorMessage,
  Alert,
  AlertIcon,
  AlertTitle,
} from "@chakra-ui/react";
import React from "react";
import { useNavigate } from "react-router-dom";
import { Form, Formik } from "formik";
import { forgotPasswordSchema } from "../utils/formValidationSchema";
import { useDispatch, useSelector } from "react-redux";
import { createsendPassword } from "../redux/slices/authSlice";
import LoginImage from "../components/LoginImage";
import { BiArrowBack } from "react-icons/bi";

const ForgotPassword = () => {
  const navigate = useNavigate();
  const [error, setError] = useState(null);
  const [isLoading, setIsLoading] = useState(null);
  const [success, setSuccess] = useState(null);
  const auth = useSelector((state) => state.auth);
  const dispatch = useDispatch();

  const initialValues = {
    email: "",
  };

  useEffect(() => {
    if (auth?.user) {
      return navigate("/");
    }
  }, [auth?.user, navigate]);

  const handleSubmit = async (values) => {
    setIsLoading(true);
    setError(null);
    setSuccess(null);

    try {
      const resultAction = await dispatch(
        createsendPassword(values.email)
      ).unwrap();

      if (resultAction?.isSuccessful) {
        setSuccess(
          resultAction?.successMessage ||
            "Password reset link sent successfully"
        );
      } else {
        throw new Error(resultAction?.error || "Something went wrong");
      }
    } catch (err) {
      setError(err.message || "Something went wrong");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Flex w="full" h="100vh" overflow={"hidden"}>
      <LoginImage />
      <Flex
        h={"full"}
        w="full"
        justify={"center"}
        position={"relative"}
        alignItems={"center"}
      >
        <Flex w={["90%", "80%", "90%", "80%"]}>
          <Flex
            direction={"column"}
            bg={"white"}
            width={"full"}
            px={"1.5rem"}
            py="2rem"
          >
            <BiArrowBack
              size={"1.5rem"}
              style={{ marginBottom: "2rem", cursor: "pointer" }}
              onClick={() => navigate("/")}
            />

            <Flex justify={"space-between"} direction={"column"} mb="1.5rem">
              <Text fontWeight={"700"} fontSize={"1.8rem"}>
                Forget Password?
              </Text>
              <Text fontSize={"1.25rem"}>
                Enter your email address to reset password
              </Text>
            </Flex>

    
            {success && (
              <Alert status="success" mb={4}>
                <AlertIcon />
                <AlertTitle>{success}</AlertTitle>
              </Alert>
            )}

            {error && (
              <Alert status="error" mb={4}>
                <AlertIcon />
                <AlertTitle>{error}</AlertTitle>
              </Alert>
            )}

            <Formik
              enableReinitialize
              initialValues={initialValues}
              validationSchema={forgotPasswordSchema}
              onSubmit={(values) => handleSubmit(values)}
            >
              {({ errors, touched, handleBlur, handleChange }) => (
                <Form mt={4}>
                  <FormControl
                    isInvalid={errors.email && touched.email}
                    mb={5}
                    color="black"
                  >
                    <FormLabel>Email</FormLabel>
                    <Input
                      placeholder="Enter email address"
                      bgColor={"#F3F3F3"}
                      borderRadius={0}
                      borderColor={"transparent"}
                      mb="1rem"
                      name="email"
                      onBlur={handleBlur}
                      onChange={handleChange}
                    />
                    {touched.email && errors.email && (
                      <FormErrorMessage>{errors.email}</FormErrorMessage>
                    )}
                  </FormControl>

                  <Button
                    isLoading={isLoading}
                    color={"white"}
                    bgColor={"#23A455"}
                    borderRadius="8px"
                    mt={"4rem"}
                    mb="1rem"
                    w={"full"}
                    type="submit"
                  >
                    Send
                  </Button>
                </Form>
              )}
            </Formik>
          </Flex>
        </Flex>
      </Flex>
    </Flex>
  );
};

export default ForgotPassword;
